import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DELETE, GET, POST, PUT } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

export const GetPersonalProperty = createAsyncThunk(
  "property/get-personal-rental-property",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.GetPersonalProperty}?name=${filter?.name || ""}&property_status_id=${
          filter?.property_status_id || ""
        }&purpose_id=${filter?.purpose_id || ""}&property_type_id=${
          filter?.property_type_id || ""
        }&posted_by_id=${filter?.posted_by_id || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for sending OTP
export const StepOnePostProperty = createAsyncThunk(
  "add-property/step-one-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepOnePost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepOne = createAsyncThunk(
  "add-property/step-one-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepOneGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StepTwoPostProperty = createAsyncThunk(
  "add-property/step-two-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepTwoPost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepTwo = createAsyncThunk(
  "add-property/step-two-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepTwoGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StepThreePostProperty = createAsyncThunk(
  "add-property/step-three-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepThreePost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepThree = createAsyncThunk(
  "add-property/step-three-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepThreeGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StepFourPostProperty = createAsyncThunk(
  "add-property/step-four-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepFourPost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepFour = createAsyncThunk(
  "add-property/step-four-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepFourGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const DeleteStepFourImage = createAsyncThunk(
  "add-property/image-delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(
        `${APIS.AddProperty.StepFourDeleteImage}/${id}`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const StepFivePostProperty = createAsyncThunk(
  "add-property/step-five-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepFivePost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepFive = createAsyncThunk(
  "add-property/step-five-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepFiveGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StepSixPostProperty = createAsyncThunk(
  "add-property/step-six-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepSixPost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepSix = createAsyncThunk(
  "add-property/step-six-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepSixGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StepSevenPostProperty = createAsyncThunk(
  "add-property/step-seven-post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.AddProperty.StepSevenPost, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Something went wrong",
        },
      );
    }
  },
);

export const GetStepSeven = createAsyncThunk(
  "add-property/step-seven-get",
  async ({ propertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AddProperty.StepSevenGet}/${propertyId}?name=${name}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Status = createAsyncThunk(
  "add-property/status-change",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.AddProperty.Status}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "rentalproperty",

  initialState: {
    data: [],
    status: IDS.SLICESTATUS.Idle,
    error: null,
    get_step_one_data: {},
    get_step_two_data: {},
    get_step_three_data: {},
    get_step_four_data: {},
    get_step_five_data: {},
    get_step_six_data: {},
    get_step_seven_data: {},
  },
  reducers: {
    resetContactState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
    clearPropertyData: (state) => {
      state.get_step_one_data = {};
      state.get_step_two_data = {};
      state.get_step_three_data = {};
      state.get_step_four_data = {};
      state.get_step_five_data = {};
      state.get_step_six_data = {};
      state.get_step_seven_data = {};
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(StepOnePostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepOnePostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepOnePostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepOne.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepOne.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_one_data = action.payload || [];
      })
      .addCase(GetStepOne.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StepTwoPostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepTwoPostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepTwoPostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepTwo.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepTwo.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_two_data = action.payload || [];
      })
      .addCase(GetStepTwo.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StepThreePostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepThreePostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepThreePostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepThree.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepThree.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_three_data = action.payload || [];
      })
      .addCase(GetStepThree.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StepFourPostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepFourPostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepFourPostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepFour.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepFour.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_four_data = action.payload || [];
      })
      .addCase(GetStepFour.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteStepFourImage.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(DeleteStepFourImage.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        if (state.get_step_four_data?.images) {
          state.get_step_four_data.images =
            state.get_step_four_data.images.filter(
              (img) => img.id !== action.meta.arg,
            );
        }
      })

      .addCase(DeleteStepFourImage.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StepFivePostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepFivePostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepFivePostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepFive.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepFive.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_five_data = action.payload || [];
      })
      .addCase(GetStepFive.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StepSixPostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepSixPostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepSixPostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepSix.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepSix.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_six_data = action.payload || [];
      })
      .addCase(GetStepSix.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StepSevenPostProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepSevenPostProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data?.unshift(action.payload.data);
      })
      .addCase(StepSevenPostProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepSeven.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepSeven.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_step_seven_data = action.payload || [];
      })
      .addCase(GetStepSeven.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetPersonalProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetPersonalProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetPersonalProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id,
        ); // Remove the country with the deleted id
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetContactState, clearPropertyData } = Slice.actions;
export default Slice.reducer;
